// @ts-check

import { useCallback, useState } from "react";

/**
 * @template T
 * @param {string} key
 * @param {T} defaultValue
 * @returns {[T, (value: T) => void]}
 */
export default function useSessionStorageState(key, defaultValue) {
    const storedValue = window.sessionStorage?.getItem(key);
    const [state, _setState] = useState(storedValue ? JSON.parse(storedValue) : defaultValue);
    
    const setState = useCallback((value) => {
        window.sessionStorage?.setItem(key, JSON.stringify(value));
        _setState(value);
    }, [key]);

    return [state, setState];
}
